"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Drawing = _interopRequireDefault(require("../../style/annotations/Drawing.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var DRAWING_PADDING = 5;
var TRANSPARENT_STROKE_WIDTH = 16;
var POINTER_EVENTS_SUPPORTED = !!window.PointerEvent;
/**
 * Drawing component
 * @param {Object} props - property object
 * @returns {ReactElement} markup
 */

var Drawing = function Drawing(_ref) {
  var annotation = _ref.annotation,
      annotationId = _ref.annotationId,
      commentProposedForDelete = _ref.commentProposedForDelete,
      disableInteraction = _ref.disableInteraction,
      hoveredAnnotation = _ref.hoveredAnnotation,
      isPlacingAnnotation = _ref.isPlacingAnnotation,
      onDrawingDown = _ref.onDrawingDown,
      onDrawingHover = _ref.onDrawingHover,
      scaleFactorX = _ref.scaleFactorX,
      scaleFactorY = _ref.scaleFactorY;
  var selector = annotation.target.selector;
  var pathColor = selector.strokeColor;
  var pathWidth = selector.strokeWidth;
  var boundingBox = selector.boundingBox;
  var left = boundingBox[0] * scaleFactorX - DRAWING_PADDING;
  var top = boundingBox[1] * scaleFactorY - DRAWING_PADDING;
  var width = (boundingBox[2] - boundingBox[0]) * scaleFactorX + DRAWING_PADDING * 2;
  var height = (boundingBox[3] - boundingBox[1]) * scaleFactorY + DRAWING_PADDING * 2;
  var paths = (0, _react.useMemo)(function () {
    return selector.inkList.map(function (points) {
      var path = points.reduce(function (acc, point, index) {
        var x = point.x * scaleFactorX;
        var y = point.y * scaleFactorY;

        if (!isNaN(x) && !isNaN(y)) {
          return index === 0 ? "M ".concat(x, " ").concat(y) : "".concat(acc, " ").concat(x, " ").concat(y);
        }

        return acc;
      }, '');
      return path;
    });
  }, [scaleFactorX, scaleFactorY, selector.inkList]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-html2canvas-ignore": annotationId === 'annotation-placeholder' ? null : true,
    className: "".concat(_Drawing.default.component).concat(annotationId === 'annotation-placeholder' ? ' temp-drawing' : '').concat(hoveredAnnotation === annotationId || commentProposedForDelete && annotationId === commentProposedForDelete.id ? ' hovered-drawing' : '').concat(isPlacingAnnotation || disableInteraction ? ' ignore-mouse-events' : ''),
    "data-annotationid": annotationId,
    "data-annotationtype": "draw",
    style: {
      left: "".concat(left, "px"),
      top: "".concat(top, "px"),
      height: "".concat(height, "px"),
      width: "".concat(width, "px")
    },
    onPointerDown: POINTER_EVENTS_SUPPORTED ? onDrawingDown : undefined,
    onMouseDown: POINTER_EVENTS_SUPPORTED ? undefined : onDrawingDown,
    onTouchStart: POINTER_EVENTS_SUPPORTED ? undefined : onDrawingDown,
    onMouseEnter: onDrawingHover,
    onMouseLeave: onDrawingHover
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "".concat(left, " ").concat(top, " ").concat(width, " ").concat(height)
  }, paths.map(function (path, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: path,
      style: {
        fill: 'none',
        stroke: pathColor || '#000',
        strokeWidth: (pathWidth || 5) * ((scaleFactorX + scaleFactorY) / 2)
      }
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: path,
      style: {
        fill: 'none',
        stroke: 'none',
        strokeWidth: TRANSPARENT_STROKE_WIDTH
      }
    }));
  })));
};

Drawing.propTypes = {
  allAnnotations: _propTypes.default.array,
  annotation: _propTypes.default.object,
  commentProposedForDelete: _propTypes.default.object,
  disableInteraction: _propTypes.default.bool,
  hoveredAnnotation: _propTypes.default.string,
  imsData: _propTypes.default.object,
  isPlacingAnnotation: _propTypes.default.bool,
  markHovered: _propTypes.default.bool,
  onDrawingDown: _propTypes.default.func,
  onDrawingHover: _propTypes.default.func,
  annotationId: _propTypes.default.string,
  scaleFactorX: _propTypes.default.number,
  scaleFactorY: _propTypes.default.number,
  showResolvedComments: _propTypes.default.bool,
  touchPressed: _propTypes.default.bool
};
var _default = Drawing;
exports.default = _default;